import React, { useState } from 'react'
import { TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { useDebouncedCallback } from 'use-debounce'

import { Flag } from 'src/api/models'
import { skuit } from 'src/services/skuit'
import { useQueryPaginator } from 'src/components/Table'
import { FilterProps } from './types'

export const FlagFilter = (props: FilterProps) => {
  const { label, onChange } = props
  const [flag, setFlag] = useState<Flag | null>(null)
  const paginator = useQueryPaginator(
    'flag-filter',
    skuit.sc.freight.orders.flags.list
  )
  const dePaginatorFilters = useDebouncedCallback(paginator.patchFilters, 100)
  return (
    <Autocomplete
      id="flag-filter"
      options={paginator.data.results}
      getOptionLabel={(flag: Flag) => flag?.name || ''}
      getOptionSelected={(option, value) => option.guid === value?.guid}
      filterOptions={(option) => option}
      onChange={(event: any, newValue: any | null) => {
        setFlag(newValue)
        onChange(newValue, newValue?.guid)
      }}
      value={flag}
      renderInput={(params) => (
        <TextField
          {...params}
          name="flag-filter"
          label={label}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            dePaginatorFilters.callback({ search: event.target.value })
          }
        />
      )}
    />
  )
}
